import registration from './registration/index';

const config = [ ...registration ];

export default config;